import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminRoutingModule } from './admin-routing.module';
import {
  HomeWardLookupComponent,
  HomeWardStudentComponent,
  HousingWardAssignmentsLookupComponent,
  HousingWardAssignmentsComponent,
  LocalWardAssignmentsLookupComponent,
  LocalWardAssignmentsComponent,
  CampusUnitProxyComponent,
  CampusStakesComponent
} from '../admin';
import { CampusWardsComponent } from './campus-wards/campus-wards.component';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CampusUnitsCommunicationsComponent } from './campus-units-communications/campus-units-communications.component';
import { NewQuestionDialogComponent } from './campus-units-communications/new-question-dialog/new-question-dialog.component';
import { NewSectionDialogComponent } from './campus-units-communications/new-section-dialog/new-section-dialog.component';
import { AppModule } from '../app.module';



@NgModule({
  imports: [
    CommonModule,
    AdminRoutingModule,
    SharedModule,
    ReactiveFormsModule
  ],
  declarations: [
    HomeWardLookupComponent,
    CampusWardsComponent,
    CampusStakesComponent,
    HomeWardStudentComponent,
    HousingWardAssignmentsLookupComponent,
    HousingWardAssignmentsComponent,
    LocalWardAssignmentsLookupComponent,
    LocalWardAssignmentsComponent,
    CampusUnitProxyComponent,
    CampusUnitsCommunicationsComponent,
    NewQuestionDialogComponent,
    NewSectionDialogComponent,
  ],
  entryComponents: [
    NewQuestionDialogComponent,
    NewSectionDialogComponent
  ]


})
export class AdminModule { }
